import { Injectable, inject } from "@angular/core"
import { MatSnackBar } from "@angular/material/snack-bar"
import { ToastComponent } from "src/app/components/toast/toast.component"

export interface ToastMessage {
    severity?: string
    summary?: string
    detail?: string
    life?: number
}

@Injectable({
    providedIn: "root",
})
export class ToastService {
    private readonly _snackBar = inject(MatSnackBar)

    add(message: ToastMessage): void {
        const text = message.detail || message.summary || ""
        if (!text) return

        this._snackBar.openFromComponent(ToastComponent, {
            data: message,
            duration: message.life ?? 5000,
            horizontalPosition: "end",
            verticalPosition: "top",
            panelClass: ["valben-snackbar"],
        })
    }
}
